/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliParentLinkedDto } from '../../models/amoxcalli-parent-linked-dto';

export interface ApiParentStudentsByStudentStudentIdGet$Plain$Params {
  studentId: string;
  institutionId?: string;
}

export function apiParentStudentsByStudentStudentIdGet$Plain(http: HttpClient, rootUrl: string, params: ApiParentStudentsByStudentStudentIdGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<AmoxcalliParentLinkedDto>>> {
  const rb = new RequestBuilder(rootUrl, apiParentStudentsByStudentStudentIdGet$Plain.PATH, 'get');
  if (params) {
    rb.path('studentId', params.studentId, {});
    rb.query('institutionId', params.institutionId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<AmoxcalliParentLinkedDto>>;
    })
  );
}

apiParentStudentsByStudentStudentIdGet$Plain.PATH = '/api/parent-students/by-student/{studentId}';
